import { render, staticRenderFns } from "./SelectTypeSchoolLevelToolbar.vue?vue&type=template&id=35b1137b&scoped=true&"
import script from "./SelectTypeSchoolLevelToolbar.vue?vue&type=script&lang=js&"
export * from "./SelectTypeSchoolLevelToolbar.vue?vue&type=script&lang=js&"
import style0 from "./SelectTypeSchoolLevelToolbar.vue?vue&type=style&index=0&id=35b1137b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b1137b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VList,VListItem,VListItemTitle,VMenu})
